import { render, staticRenderFns } from "./UpdateTelegramChannel.vue?vue&type=template&id=730e8bc1&scoped=true"
import script from "./UpdateTelegramChannel.vue?vue&type=script&lang=js"
export * from "./UpdateTelegramChannel.vue?vue&type=script&lang=js"
import style0 from "./UpdateTelegramChannel.vue?vue&type=style&index=0&id=730e8bc1&prod&lang=scss&scoped=true"
import style1 from "./UpdateTelegramChannel.vue?vue&type=style&index=1&id=730e8bc1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730e8bc1",
  null
  
)

export default component.exports